import SaveSelectionIconDark from 'assets/images/icons/dark - save selection.svg?react';
import SaveSelectionIconSimpleFiligree from 'assets/images/icons/simple filigree - save selection.svg?react';
import SaveSelectionIconSpringVibes from 'assets/images/icons/spring - save selection.svg?react';
import SaveSelectionIconVickyBaumannBoho from 'assets/images/icons/vicky boho - save selection.svg?react';
import SaveSelectionIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - save selection.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacySaveSelectionIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={SaveSelectionIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={SaveSelectionIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={SaveSelectionIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={SaveSelectionIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={SaveSelectionIconSimpleFiligree} {...props} />
  })();

export const SaveSelectionIcon = (props: IIconProps) => (
  <SetIcon slug="save" fallback={LegacySaveSelectionIcon} {...props} />
);
